// The relay pass as a text file to keep. Made in the browser from what's
// already on the page; nothing is sent anywhere.

import type { PassStatus } from '@sss/types';
import { downloadBytes, formatBytes } from './tools';

export const PASS_FILE_NAME = 'relay-pass.txt';

export const passFileText = (pass: string, origin: string, status: PassStatus | null, locale = 'en'): string =>
  [
    'Simple Secret Sharing relay pass',
    '',
    pass,
    '',
    ...(status
      ? [`${formatBytes(status.bytesLeft)} left of ${formatBytes(status.bytesTotal)}, until ${new Date(status.expiresAt).toLocaleDateString(locale, { dateStyle: 'long' })}.`, '']
      : []),
    'Keep it like a password: anyone with this pass can spend it.',
    `To use it, open ${origin}/live, choose Files, and paste it into "Relay pass".`,
    '',
  ].join('\n');

/** Save the pass as a .txt file through the browser's download. */
export const downloadPass = (pass: string, status: PassStatus | null, locale?: string): void =>
  downloadBytes(new TextEncoder().encode(passFileText(pass, window.location.origin, status, locale)), PASS_FILE_NAME);
